const filterEventsForm = document.getElementById( 'filter-events-form' );

if ( filterEventsForm ) {
	const radios = filterEventsForm.querySelectorAll( 'input[type="radio"]' );
	radios.forEach( radio => {
		radio.addEventListener( 'change', () => {
			console.log( radio.checked );
			if ( radio.checked ) {
				// radio.checked = false;
			}
		});
	})
}
